module.exports = __webpack_public_path__ + "static/media/10-3-redcube.c00877dd.png";